<template>
  <QuotationTable 
    :opportunity="opportunity" 
    :quotations="quotations" 
    :loading="loading"
    @reload="reload"
    :key="display"
    @confirmDelete="deleteQuotation"
  />
</template>
<script>
import QuotationTable from "@/mbp/opportunities/quotationsTab/Quotation-Table.vue";
import OpportunityService from "@/service/OpportunityService";
import QuotationService from "@/service/QuotationService";
export default {
  props: ["opportunity"],
  components: {
    QuotationTable,
  },
  data: () => ({
    quotations: [],
    display: 0,
    loading: false
  }),
  opportunityService: null,
  quotationService: null,
  created() {
    this.opportunityService = new OpportunityService();
    this.quotationService = new QuotationService();
  },
  mounted() {
    this.getQuotations()
  },
  computed: {
    myPermissions() {
        return this.$store.getters['auth/getUserPermissions']
    },
  },
  methods: {
    deleteQuotation(data) {
      let permission = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteQuotationAdmin');
      if (permission) {
          if (permission.permissionLevel === 0) {
            let per = this.myPermissions.find(a => a.permission.permissionCode === 'DeleteQuotation');
            if(per.permissionLevel === 0)
            {
              this.$toast.add({
                severity: "error",
                summary: "Not allowed",
                detail: "You don't have permission to Delete Quotations",
                life: 5000,
              })
            } else if (per.permissionLevel === 1) {
                if(data && data.quoteStatus && data.quoteStatus.id && data.quoteStatus.id == 1)
                {
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Only Quotations with 'NEW' status can be deleted",
                    life: 5000,
                  })                  
                }
                else if (data && data.quoteVerId) {
                  this.quotationService
                    .deleteQuotation(data.quoteVerId)
                    .then((data) => {
                      this.$toast.add({
                        severity: "warn",
                        summary: "Warning",
                        detail: data,
                        life: 5000,
                      })
                      this.reload()
                    })
                    .catch(error => {
                      this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: error.response.data,
                        life: 5000,
                      })
                    })
                }
            }
            else if (per.permissionLevel === 2) // Allow if Cancelled or  Closed 
            {
              // 3 => Cancelled
              // 4 => Closed
              if(data && data.quoteStatus && data.quoteStatus.id && (data.quoteStatus.id == 3 || data.quoteStatus == 4))
              {
                if (data && data.quoteVerId) {
                  this.quotationService
                    .deleteQuotation(data.quoteVerId)
                    .then((data) => {
                      this.$toast.add({
                        severity: "warn",
                        summary: "Warning",
                        detail: data,
                        life: 5000,
                      })                            
                      this.reload()
                    })
                    .catch(error => {
                      this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: error.response.data,
                        life: 5000,
                      })
                    })
                }
              } else {
                this.$toast.add({
                  severity: "error",
                  summary: "Not allowed",
                  detail: "You are not allowed to delete a Quotation",
                  life: 5000,
                })
              }
            }
        } else if (permission.permissionLevel === 1) {
            if (data && data.quoteVerId) {
              this.quotationService
                .deleteQuotationWithRelatedRecords(data.quoteVerId)
                .then((data) => {
                      this.$toast.add({
                        severity: "warn",
                        summary: "Warning",
                        detail: data,
                        life: 5000,
                      })
                  this.reload()
                })
                .catch(error => {
                  
                  this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: error.response.data,
                    life: 5000,
                  })
                })
            }
        } 
      }   
    },
    getQuotations() {
      this.loading = true
      this.opportunityService
        .getAllOpportunityQuotes(this.opportunity.oppId)
        .then(data => {
          this.loading = false

          
          this.quotations = data
          this.display++
        })
        .catch(err => {
          this.loading = false
          
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting quotations",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "opportunityquotes/{oppId}"'
          })
        })
    },
    reload() {
      
      this.getQuotations()
    }
  }
};
</script>